/*
*   File : watchlist.js
*   Author : https://evoqins.com
*   Description : Kyc verification page
*   Integrations : NA
*   Version : 1.0.0
*/

import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";


// Components
import { WatchListCard } from "../../Component/Cards";
import { EmptyScreen, Loader } from "../../Component/Others";
import { APIService } from "../../Service";
import { _scrollToTop } from "../../Helper";

// Assets
import EmptyWatchList from '../../Assets/Images/EmptyScreen/empty-watchlist.webp';

function Watchlist() {

  const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);
  const navigate = useNavigate();
  const [watchList, setWatchList] = useState({});
  const [dataLoading, setDataLoading] = useState(true);

  useEffect(() => {
    // Scroll the page to top
    _scrollToTop();

    // API call
    _getWatchList();
  }, []);


  // handle navigate to explore page
  const _handleStartInvesting = () => {
    navigate("/explore");
  };


  // Get portfolio list
  const _getWatchList = async () => {

    let url = "portfolio/watchlist/list";
    let data = {
      "user_id": USER_DATA.unique_identifier
    };

    const response = await APIService(url, data);

    if (response.status_code === 200) {
      setWatchList(response.data);
    } else {
      setWatchList("");
    }

    setDataLoading(false);
  };


  return (
    <div className="p-3 p-sm-4 card-box-shadow e-bg-white min-vh-100 margin-26px-bottom">
      {
        dataLoading ?
          <Loader wrapperClassName="min-vh-100 margin-200px-top" />
          :
          watchList && watchList.count > 0 ?
            <div>
              <h6 className="e-font-16-res mb-0 e-text-primary-color e-primary-font-clash-display e-font-weight-500 e-font-20 line-height-24px">
                Watchlist ({watchList.count})
              </h6>

              <div className="col-sm-10 col-md-8 col-lg-6 d-flex flex-column gap-3 margin-32px-top margin-24px-top-res">
                {
                  watchList.watch_list.map((product, index) => (
                    <WatchListCard key={index}
                      category={1}
                      product={product} />
                  ))
                }
              </div>
            </div>
            :
            <div>
              <h4 className='e-font-18-res e-primary-font-clash-display e-text-primary-color e-font-20 e-font-weight-500 line-height-24px'>
                Watchlist
              </h4>
              <EmptyScreen
                type={1}
                emptyScreenImage={EmptyWatchList}
                description="Let's Start Tracking alphaBasket! Add some alphaBaskets to your watchlist to updated on their performance."
                btnLabel="Start Investing"
                onClick={_handleStartInvesting} />
            </div>
      }
    </div>
  )
}

export default Watchlist;